import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { SearchProvider } from "./context/SearchContext";
import { AuthProvider } from "./context/AuthContext";
import { MarketProvider } from "./context/MarketContext";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import AtlasVehicles from "./pages/AtlasVehicles";
import AtlasVehicleDetail from "./pages/AtlasVehicleDetail";
import AtlasCompare from "./pages/AtlasCompare";
import Trust from "./pages/Trust";
import Coverage from "./pages/Coverage";
import Partners from "./pages/Partners";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import ReportIssue from "./pages/ReportIssue";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Account from "./pages/Account";
import LegalTerms from "./pages/legal/Terms";
import LegalPrivacy from "./pages/legal/Privacy";
import LegalDataSources from "./pages/legal/DataSources";
import IntelligenceHome from "./pages/IntelligenceHome";
import OpportunityWorkspace from "./pages/OpportunityWorkspace";
import OpportunityReportPage from "./pages/OpportunityReportPage";
import DealerProfile from "./pages/DealerProfile";
import ToolsHub from "./pages/ToolsHub";
import PublicReport from "./pages/PublicReport";

function AppRouter() {
  const location = useLocation(); // read hash here (reactive), not window.location.hash
  // Google OAuth returns to {origin}/...#session_id=... — intercept it FIRST,
  // before any protected-route/auth check runs, to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* Atlas Intelligence — B2B acquisition (manual-first). */}
      <Route path="/intelligence" element={<IntelligenceHome />} />
      <Route path="/intelligence/new" element={<OpportunityWorkspace />} />
      <Route path="/intelligence/:id" element={<OpportunityReportPage />} />
      <Route path="/dealer-profile" element={<DealerProfile />} />
      <Route path="/tools" element={<ToolsHub />} />
      {/* Public dealer-facing shared report (unguessable token, noindex). */}
      <Route path="/r/:token" element={<PublicReport />} />
      {/* Live search repositioned as the internal operator Sourcing tool. */}
      <Route path="/atlas" element={<AtlasVehicles />} />
      <Route path="/atlas/vehicle/:source/:id" element={<AtlasVehicleDetail />} />
      <Route path="/atlas/compare" element={<AtlasCompare />} />
      {/* Retired seed-data prototype routes -> redirect into the live pipeline. */}
      <Route path="/search" element={<Navigate to="/atlas" replace />} />
      <Route path="/results" element={<Navigate to="/atlas" replace />} />
      <Route path="/compare" element={<Navigate to="/atlas" replace />} />
      <Route path="/vehicle/:id" element={<Navigate to="/atlas" replace />} />
      <Route path="/trust" element={<Trust />} />
      <Route path="/coverage" element={<Coverage />} />
      <Route path="/list-your-source" element={<Partners />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/account" element={<Account />} />
      <Route path="/report" element={<ReportIssue />} />
      <Route path="/legal/terms" element={<LegalTerms />} />
      <Route path="/legal/privacy" element={<LegalPrivacy />} />
      <Route path="/legal/data-sources" element={<LegalDataSources />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <MarketProvider>
          <SearchProvider>
            <Layout>
              <AppRouter />
            </Layout>
          </SearchProvider>
        </MarketProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
